import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { UserDetailListWrapper } from '../../../../styles/main/user'
import FilterLayout from '../../../layout/filter/FilterLayout'
import { useWindowSize } from '../../../../core/hooks/common/useWindowSize'
import NotificationTable from '../../reports/notifications/NotificationTable'
import { useGetNotifications } from '../../../../core/services/react-query/report/notifications'
import {
    CacheKeys,
    userNotificationsOptions,
} from '../../../../core/constants/filter'
import { TABLET_SIZE } from '../../../../core/constants/common'
import RNotificationTable from '../../../responsive/main/reports/notifications/RNotificationTable'

export default function UserNotifications() {
    const params = useParams()
    const { width } = useWindowSize()

    const [notifications, setNotifications] = useState({
        loading: true,
        data: null,
    })

    console.log(notifications)

    const onQuerySuccess = (res) => {
        setNotifications(res)
    }
    const Component =
        width > TABLET_SIZE ? NotificationTable : RNotificationTable

    return (
        <UserDetailListWrapper>
            <FilterLayout
                query={useGetNotifications}
                options={userNotificationsOptions}
                cache={CacheKeys.USER_NOTIFICATIONS}
                onQuerySuccess={onQuerySuccess}
                extra={{ receptorId: params.id }}>
                <Component data={notifications} />
            </FilterLayout>
        </UserDetailListWrapper>
    )
}
